import './App.css';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import TopNav from './Components/TopNav/TopNav';
import Footer from './Components/Footer/Footer';
import CartDrawer from './Components/CartDrawer/CartDrawer';
import CartPage from './Pages/CartPage';
import HomePage from './Pages/HomePage';
import AboutPage from './Pages/AboutPage';
import ContactPage from './Pages/ContactPage';
import GetFaceMatchingPage from './Pages/GetFaceMatchingPage';
import ProductDetailsPage from './Pages/ProductDetailsPage';
import ProductsPage from './Pages/ProductsPage';
import OffersPage from './Pages/OffersPage';
import LoginPage from './Pages/LoginPage';
import SignupPage from './Pages/SignupPage';
import CheckoutPage from './Pages/CheckoutPage';
import OrdersPage from './Pages/OrdersPage';
import ProfilePage from './Pages/ProfilePage';
import AdminDashboardPage from './Pages/AdminDashboardPage';
import AddressesPage from './Pages/AddressesPage';
import SettingsPage from './Pages/SettingsPage';
import AppointmentPage from './Pages/AppointmentPage';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import { useAuth } from './context/AuthContext';

function AdminRoute({ children }) {
  const { isAuthenticated, user } = useAuth();

  if (!isAuthenticated) {
    return <Navigate to="/login" replace state={{ from: '/admin' }} />;
  }

  if (!user?.isAdmin) {
    return <Navigate to="/" replace />;
  }

  return children;
}

function App() {
  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <Routes>
            <Route
              path="/admin"
              element={(
                <AdminRoute>
                  <AdminDashboardPage />
                </AdminRoute>
              )}
            />
            <Route
              path="*"
              element={(
                <div className="app-shell">
                  <TopNav />
                  <main className="app-content">
                    <Routes>
                      <Route path="/" element={<HomePage />} />
                      <Route path="/products" element={<ProductsPage />} />
                      <Route path="/offers" element={<OffersPage />} />
                      <Route path="/products/:productId" element={<ProductDetailsPage />} />
                      <Route path="/cart" element={<CartPage />} />
                      <Route path="/checkout" element={<CheckoutPage />} />
                      <Route path="/orders" element={<OrdersPage />} />
                      <Route path="/profile" element={<ProfilePage />} />
                      <Route path="/appointments" element={<AppointmentPage />} />
                      <Route path="/account/addresses" element={<AddressesPage />} />
                      <Route path="/account/settings" element={<SettingsPage />} />
                      <Route path="/login" element={<LoginPage />} />
                      <Route path="/signup" element={<SignupPage />} />
                      <Route path="/about" element={<AboutPage />} />
                      <Route path="/contact" element={<ContactPage />} />
                      <Route path="/getfacematching" element={<GetFaceMatchingPage />} />
                      <Route path="*" element={<Navigate to="/" replace />} />
                    </Routes>
                  </main>
                  <CartDrawer />
                  <Footer />
                </div>
              )}
            />
          </Routes>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;
